import { normalizeTableRows } from "./normalizeTableRows";

/**
 * Normalize execute-sql API payloads into row arrays for table pagination.
 * @param {object} response
 * @param {object[]|null} referenceRows — existing displayed rows (Messages API schema)
 */
export function parseExecuteSqlResponse(response, referenceRows = null) {
  if (!response || typeof response !== "object") {
    return { rows: [], pagination: {}, dataSummary: {}, ok: false };
  }

  const pickRows = (payload) => {
    if (!payload) return [];
    if (Array.isArray(payload)) return payload;
    if (typeof payload !== "object") return [];

    return (
      (Array.isArray(payload.data) && payload.data) ||
      (Array.isArray(payload.results) && payload.results) ||
      (Array.isArray(payload.raw_results) && payload.raw_results) ||
      (Array.isArray(payload.rows) && payload.rows) ||
      (Array.isArray(payload.records) && payload.records) ||
      (Array.isArray(payload.result_data) && payload.result_data) ||
      []
    );
  };

  let rows = pickRows(response);
  if (rows.length === 0 && response.data && typeof response.data === "object") {
    rows = pickRows(response.data);
  }
  if (rows.length === 0 && response.result && typeof response.result === "object") {
    rows = pickRows(response.result);
  }
  if (
    rows.length === 0 &&
    response.visualization_data &&
    typeof response.visualization_data === "object"
  ) {
    rows = pickRows(response.visualization_data);
  }
  if (
    rows.length === 0 &&
    response.metadata?.visualization_data &&
    typeof response.metadata.visualization_data === "object"
  ) {
    rows = pickRows(response.metadata.visualization_data);
  }

  const pagination =
    response.pagination ||
    response.data?.pagination ||
    response.result?.pagination ||
    {};
  const dataSummary =
    response.data_summary ||
    response.dataSummary ||
    response.data?.data_summary ||
    response.data?.dataSummary ||
    response.result?.data_summary ||
    {};

  const explicitFailure = response.success === false || response.ok === false;
  const explicitSuccess = response.success === true || response.ok === true;
  const hasMoreFalse =
    pagination.has_more === false ||
    pagination.hasMore === false ||
    pagination.has_next === false;

  const ok = !explicitFailure && (rows.length > 0 || explicitSuccess || hasMoreFalse);

  const normalizedRows = normalizeTableRows(rows, referenceRows);

  return { rows: normalizedRows, pagination, dataSummary, ok };
}
